import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
} from '@appblocks/codegeneration/types';

export default class NodePort extends BaseFeature {
    constructor() {
        super();
        this.name = 'Node Port';
        this.id = 'node_port';

        const settings: Setting[] = [
            {
                id: 'NAME',
                name: 'Name',
                settingType: SettingType.STRING,
                required: true,
                default: '',
            },
            {
                id: 'PORTID',
                name: 'Port ID',
                settingType: SettingType.STRING,
                required: true,
                default: '',
            },
            {
                id: 'PARAMS',
                name: 'Parameters',
                settingType: SettingType.ARRAY,
                required: true,
                refId: 'node_parameter',
                default: [],
            },
        ];

        this.settings = this.settings.concat(settings);
    }
}
